/**
 * Ширина фиксированной плашки хедера
 *
 * @name constants.BAR_WIDTH
 * @type {number}
 */
export const BAR_WIDTH = 54;

/**
 * Позиция фиксированного элемнта (плашки)
 *
 * @name constants.BOUNDING_RECT_FIXED
 * @type {number}
 */
export const BOUNDING_RECT_FIXED = 100;

/**
 * @name constants.ZERO
 * @type {number}
 */
export const ZERO = 0;

/**
 * @name constants.BACKGROUND_COLOR_BLACK
 * @type {string}
 */
export const BACKGROUND_COLOR_BLACK = '#101125';

/**
 * @name constants.GREY_TEXT_COLOR
 * @type {string}
 */
export const GREY_TEXT_COLOR = '#929292';

/**
 * @name constants.LABELS
 * @type {enum}
 */
export enum ELABELS {
    header = 'header',
    firstScreen = 'first screen',
    watchNowPayLater = 'watch now pay later',
    tariff = 'tariff',
    testDrive = 'test drive',
    buy = 'buy',
}
